import { ScrollTrigger } from '../lib/gsap';

// Features section: as each copy block passes the middle of the viewport it
// becomes the active one — the phone swaps screen, the chip swaps, and the pip
// fills with that block's progress.
//
// This is state, not decoration, so it also runs under reduced motion: without
// it the phone would show a screen that doesn't match the text being read.
export function initFeaturesSticky(): void {
  const root = document.querySelector<HTMLElement>('[data-features]');
  if (!root) return;

  const blocks = Array.from(root.querySelectorAll<HTMLElement>('[data-features-block]'));
  const slots = Array.from(root.querySelectorAll<HTMLElement>('[data-device-slot]'));
  const chips = Array.from(root.querySelectorAll<HTMLElement>('[data-features-chip]'));
  const pips = Array.from(root.querySelectorAll<HTMLElement>('[data-features-pip]'));
  if (blocks.length < 2) return;

  let active = -1;

  const setActive = (index: number): void => {
    if (index === active) return;
    active = index;

    blocks.forEach((block, i) => block.classList.toggle('is-active', i === index));
    slots.forEach((slot, i) => {
      slot.classList.toggle('is-active', i === index);
      slot.toggleAttribute('aria-hidden', i !== index);
    });
    pips.forEach((pip, i) => pip.classList.toggle('is-active', i === index));
    chips.forEach((chip) => {
      chip.classList.toggle('is-shown', chip.dataset.featuresChip === String(index));
    });
  };

  blocks.forEach((block, index) => {
    ScrollTrigger.create({
      trigger: block,
      start: 'top center',
      end: 'bottom center',
      onToggle: (self: { isActive: boolean }) => {
        if (self.isActive) setActive(index);
      },
      onUpdate: (self: { progress: number }) => {
        pips[index]?.style.setProperty('--fill', `${(self.progress * 100).toFixed(1)}%`);
      },
    });

    // Clicking a pip scrolls to its block.
    pips[index]?.addEventListener('click', () => {
      block.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });

  setActive(0);

  // Fonts and images shift the blocks' geometry — re-measure once they land.
  window.addEventListener('load', () => ScrollTrigger.refresh(), { once: true });
}
